import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../utils'

export const POST_EMAIL_REQUEST = 'sherrinford/email/POST_EMAIL_REQUEST'
export const POST_EMAIL_SUCCESS = 'sherrinford/email/POST_EMAIL_SUCCESS'
export const POST_EMAIL_ERROR = 'sherrinford/email/POST_EMAIL_ERROR'

export const POST_BULK_EMAIL_REQUEST = 'sherrinford/email/POST_BULK_EMAIL_REQUEST'
export const POST_BULK_EMAIL_SUCCESS = 'sherrinford/email/POST_BULK_EMAIL_SUCCESS'
export const POST_BULK_EMAIL_ERROR = 'sherrinford/email/POST_BULK_EMAIL_ERROR'

const initialStates = {
  isSent: false,
  isBulkSent: false,
}

export default createReducer(initialStates, {
  [POST_EMAIL_REQUEST]: state => ({
    ...state,
    isSent: initialStates.isSent,
  }),
  [POST_EMAIL_SUCCESS]: state => ({
    ...state,
    isSent: !initialStates.isSent,
  }),
  [POST_EMAIL_ERROR]: state => ({
    ...state,
    isSent: initialStates.isSent,
  }),

  [POST_BULK_EMAIL_REQUEST]: state => ({
    ...state,
    isBulkSent: initialStates.isBulkSent,
  }),
  [POST_BULK_EMAIL_SUCCESS]: state => ({
    ...state,
    isBulkSent: !initialStates.isBulkSent,
  }),
  [POST_BULK_EMAIL_ERROR]: state => ({
    ...state,
    isBulkSent: initialStates.isBulkSent,
  }),
})

export function postEmail(payloads, cb = () => {}) {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      POST_EMAIL_REQUEST,
      POST_EMAIL_SUCCESS,
      POST_EMAIL_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: '/email/send',
      authorization: token,
      payloads,
    },
    nextAction: res => cb(res),
  }
}

export function postBulkEmail(payloads, cb = () => { }) {
  return {
    type: [
      POST_BULK_EMAIL_REQUEST,
      POST_BULK_EMAIL_SUCCESS,
      POST_BULK_EMAIL_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: '/email/send/v2',
      payloads,
    },
    nextAction: res => cb(res),
  }
}
